import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { Redirect } from 'react-router-dom';

import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import {login} from "../actions/auth"; 

class AuthForm extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      username:'',
      password:'',
      redirectTo:false,
      next:'/'
    }
  }

  componentDidUpdate(prevProps){
    if(prevProps.auth !== this.props.auth){
      this.setState({
        redirectTo:true,
      }) 
    }
  }

  get isLogin() {
    return this.props.authState === STATE_LOGIN;
  }

  get isSignup() {
    return this.props.authState === STATE_SIGNUP;
  }

  changeAuthState = authState => event => {
    event.preventDefault();

    this.props.onChangeAuthState(authState);
  };

  handleSubmit = event => {
    event.preventDefault();
    const {username, password}= this.state 
    this.props.login(username, password)
  };

  renderButtonText() {
    const { buttonText } = this.props;

    if (!buttonText && this.isLogin) {
      return 'Ingresar';
    }

    if (!buttonText && this.isSignup) {
      return 'Signup';
    }

    return buttonText;
  }

  handleTextChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    const {username, password, redirectTo, next}= this.state;
    if (redirectTo === true) {
      return <Redirect to={next}/>
    }
    return (
      <Form onSubmit={this.handleSubmit}>
        <FormGroup>
          <Label for="username">Usuario</Label>
          <Input type="text" name="username" value={username} onChange={this.handleTextChange} placeholder="Nombre de usuario" />
        </FormGroup>
        <FormGroup>
          <Label for="password">Constraseña</Label>
          <Input type="password" name="password" value={password} onChange={this.handleTextChange} placeholder="Contraseña" />
        </FormGroup>
        <hr />
        <Button
          size="lg"
          className="bg-gradient-theme-custom-right border-0"
          block
          style={{color: 'white'}}
          color="secondary2"
          onClick={this.handleSubmit}>
          {this.renderButtonText()}
        </Button>
      </Form>
    );
  }
}

export const STATE_LOGIN = 'LOGIN';
export const STATE_SIGNUP = 'SIGNUP';

AuthForm.propTypes = {
  authState: PropTypes.oneOf([STATE_LOGIN, STATE_SIGNUP]).isRequired,
  showLogo: PropTypes.bool,
  usernameLabel: PropTypes.string,
  usernameInputProps: PropTypes.object,
  passwordLabel: PropTypes.string,
  passwordInputProps: PropTypes.object,
  confirmPasswordLabel: PropTypes.string,
  confirmPasswordInputProps: PropTypes.object,
  onLogoClick: PropTypes.func,
};

AuthForm.defaultProps = {
  authState: 'LOGIN',
  showLogo: true,
  usernameLabel: 'Usuario',
  usernameInputProps: {
    type: 'text',
    placeholder: 'Nombre de Usuario',
  },
  passwordLabel: 'Contraseña',
  passwordInputProps: {
    type: 'password',
    placeholder: 'Contraseña',
  },
  confirmPasswordLabel: 'Confirmación',
  confirmPasswordInputProps: {
    type: 'password',
    placeholder: 'confirma tu contraseña',
  },
  onLogoClick: () => {},
};

const mapStateToProps = state => ({
  auth:state.auth,
})

export default connect(mapStateToProps,{login})(AuthForm);
